import { useState, useEffect } from "react";
import { cotaUsuarioService } from "../services/cotaUsuarioService";
import { CotaUsuario } from "../interfaces/CotaUsuario";

export const useCotaUsuario = (
  cotaUsuarioId: number | undefined | null,
  fetch: boolean
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [cotaUsuario, setCotaUsuario] = useState<CotaUsuario | undefined>(
    undefined
  );

  useEffect(() => {
    const fetchCotaUsuario = async () => {
      if (cotaUsuarioId && fetch) {
        setIsLoading(true);

        try {
          const data = await cotaUsuarioService(cotaUsuarioId);
          if (data) {
            setCotaUsuario(data);
          } else {
            // Só exibe erro se os dados não forem encontrados
            console.error("Dados não encontrados para o usuário");
          }
        } catch (error) {
          // Só exibe erro se ocorrer um erro durante a requisição
          console.error("Erro ao buscar cota do usuário:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        // Não exibe erro se `cotaUsuarioId` não for válido no início
        setIsLoading(false);
      }
    };

    fetchCotaUsuario();
  }, [cotaUsuarioId, fetch]); // Dependência de usuarioId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, cotaUsuario };
};
